module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    //LOCAL CONNECTION
    API_URL: "https://heybe.degaanly.tech/api/v1",
    // PRODUCTION CONNECTION
    // API_URL: "https://apartment-api-production.up.railway.app/api/v1",
  }
};
